import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, FormLabel, Input, FormErrorMessage, Stack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import EmailValidator from "email-validator";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { ToastContainer, toast } from 'react-toastify';

export function EditClient({ isOpen = false, onClose = null, clientData = [], refreshData, creator, authKey }) {
    const initialRef = useRef(null);
    const [clientId, setClientId] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [contactPhoneNo, setContactPhoneNo] = useState('');
    const [emailIsError, setEmailIsError] = useState(false);
    const [isLoading, setIsloading] = useState(false);

    useEffect(() => {
        if (email.length > 0 && !EmailValidator.validate(email)) {
            setEmailIsError(true);
        }
        else {
            setEmailIsError(false);
        }
    }, [email]);

    useEffect(() => {
        setClientId(clientData.agentId);
        setCompanyName(clientData.agentName);
        setEmail(clientData.email);
        setContactPhoneNo(clientData.phoneNo ? clientData.phoneNo : '');
    }, [clientData]);

    const editClient = async () => {
        setIsloading(true);

        const params = {
            agentId: clientId,
            agentName: companyName.trim(),
            agentEmail: email.trim(),
            agentPhone: contactPhoneNo.trim(),
            creator
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${authKey}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('agent-edit'), params, apiHeader);
            if (response) {
                const { status } = response.data;
                if (status === 'success') {
                    refreshData(authKey);
                    setIsloading(false);
                    onClose();
                }
                else {
                    toast.error("Sorry, we are unable to modify client data at this time. Please try again later.");
                }
            }
        } catch (error) {
            toast.error("Sorry, we are unable to modify client data at this time. Please try again later.");
            await logger({ task: "Edit Client", error: error.toString() });
        }

        setIsloading(false);
    }

    const closeModal = () => {
        //clear();
        onClose();
    }

    const processForm = async (e) => {
        e.preventDefault();
        await editClient();
    }

    return (
        <>
            <Modal isCentered initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={processForm}>
                        <ModalHeader>Edit account</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={2}>
                            <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                                <FormControl isRequired mt={2}>
                                    <FormLabel>Client Identifier</FormLabel>
                                    <Input type="text" disabled={true} value={clientId} onChange={e => setClientId(e.target.value)} />
                                </FormControl>

                                <FormControl isRequired mt={4}>
                                    <FormLabel>Company name</FormLabel>
                                    <Input type="text" ref={initialRef} value={companyName} onChange={e => setCompanyName(e.target.value)} />
                                </FormControl>

                                <FormControl isInvalid={emailIsError} isRequired mt={6}>
                                    <FormLabel>Email address</FormLabel>
                                    <Input type='email' value={email} onChange={e => setEmail(e.target.value)} />
                                    {emailIsError && <FormErrorMessage>Please enter a valid email address.</FormErrorMessage>}
                                </FormControl>

                                <FormControl isRequired mt={6}>
                                    <FormLabel>Contact phone number</FormLabel>
                                    <Input type="text" value={contactPhoneNo} onChange={e => setContactPhoneNo(e.target.value)} />
                                </FormControl>
                            </div>

                        </ModalBody>

                        <ModalFooter>
                            <Stack direction={'row'}>
                                <Button onClick={closeModal}>Cancel</Button>
                                <Button disabled={emailIsError} isLoading={isLoading} type="submit" bgColor='#0C7FE9' color='white' _hover={{
                                    bg: "#3c98ed"
                                }} mr={3}>
                                    Update Client
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <ToastContainer />
        </>
    )
}